import BaseViewController from "../base-view-controller";

class AccountBillingEditViewController extends BaseViewController {
  preprocessScreenData() {
    const addSectionStyleToScreen = () => {
      this.screen.name += " section-web-sdk";
    };

    if (!this.screen.name.includes("section")) addSectionStyleToScreen();

    this.screen.fields = this.screen.fields.filter(f => f.name !== "hsaFsa");
    super.preprocessScreenData();

    const footerFields =
      this.screen.footerFields[0].fieldLayouts[0].containerFields;

    const copyDeleteButtonToFooter = () => {
      const deleteButton = this.screen.fields.find(
        f => f.name === "delete_button"
      );
      footerFields.push({
        ...deleteButton,
        name: "delete_button delete_button_footer"
      });
    };

    if (!footerFields.some(f => f.name.includes("delete_button"))) {
      copyDeleteButtonToFooter();
    }
  }

  handleButtonClick(
    name,
    text,
    action,
    replaceHistory,
    initialScreen,
    eventStates
  ) {
    if (name === "copyClearHomeAddressButton") {
      const { copyAddressTitle, clearAddressTitle } = action.data;
      const { addressLine1, addressLine2, city, state, zipcode } =
        action.data.datastore.hashifiedStorage.profileInformation
          .mailingAddress;

      const field = this.screen.fields.find(f => f.name === name);
      const addressEmpty = field.title === copyAddressTitle;

      const changeButtonText = () =>
        addressEmpty
          ? (field.title = clearAddressTitle)
          : (field.title = copyAddressTitle);

      const populateFormWithMailingAddress = () =>
        this.appData.handleChange({
          address1: addressLine1,
          address2: addressLine2,
          city,
          state,
          zip: zipcode
        });

      const clearForm = () =>
        this.appData.handleChange({
          address1: "",
          address2: "",
          city: "",
          state: "",
          zip: ""
        });

      if (addressEmpty) {
        populateFormWithMailingAddress();
      } else {
        clearForm();
      }
      changeButtonText();
    } else {
      super.handleButtonClick(
        name,
        text,
        action,
        replaceHistory,
        initialScreen,
        eventStates
      );
    }
  }
}

export default AccountBillingEditViewController;
